
<template>
	<article class="form-section-print-view">

		<div class="letterhead d-flex flex-row justify-content-between align-items-center">
			<img v-if="companyLogoSrc" :src="companyLogoSrc" class="logo mr-3">
			<div>
				<h3 class="text-right">
					<span class="ml-2">#{{ project.job_num }}: {{ project.job_name }}</span>
					<div><small class="text-muted">Project Notes</small></div>
				</h3>

				<button class="btn btn-light form-button mr-4 float-right" v-on:click="printPage">
					<i class="fa fa-print"></i>
					Print
				</button>

				<button class="btn btn-light form-button mr-2 float-right" v-on:click="sendModalVisible = true">
					<i class="fa fa-envelope"></i>
					Send
				</button>

			</div>
		</div>

		<div class="form-details" v-if="'job_num' in project && 'job_name' in project">
			<h4 class="title">
			 Notes for Project  #{{ project.job_num }}, {{ project.job_name }}
			</h4>
		</div>

		<div v-if="notes.length != 0">
			<div v-for="note in notes">
				<job-note :note="note"></job-note>
			</div>
		</div>

		<send-document-modal
			document-type="Note"
			:visible="sendModalVisible"
			:customer="project.Customer"
			:employees="project.User"
			v-on:closeModal="sendModalVisible = false"
			v-on:send="sendNotes">	
		</send-document-modal>

	</article>
</template>


<script type="text/javascript">

import TableList from "@/components/TableList"
import Field from "@/components/Field"
import SendDocumentModal from "@/components/SendDocumentModal"
import JobNote from "@/components/JobNote";

export default {
	name: "ProjectNotesPrintView",
	components: {
		TableList,
		Field,
		SendDocumentModal,
		JobNote
	},
	mixins: [],
	data() {
		return {
			notes: [],
			notesAreFetched: false,
			project: {},
			sendModalVisible: false,
			userIsVerified: false,

			notesPayload: {
				is_shared: true,
				include: [
					// First/Last name of who updated the note last
					{
						model: "User",
						fields: ["first_name", "last_name"]
					},
					{
						// Attachments
						model: "UploadFile",
						fields: ["thumb_filename", "filename", "id", "slug"]
					},
					{
						model: "Job",
						fields: ["slug"]
					}
				]
			},

			jobPayload: {
				include: [
					{
						model: "Contact",
						fields: ["SubContacts"],
						include: [
							{
								model: "Contact",
								fields: ["name", "email"]
							}
						]
					},
					{
						model: "User",
						fields: ["first_name", "last_name", "email", "id"]
					}
				]
			}

		}
	},
	computed: {
		companyLogoSrc() {
			let fileImage = {}

			if ('ProfileImage' in this.$store.company && this.$store.company.ProfileImage)
				fileImage = this.$store.company.ProfileImage

			if (fileImage)
				return window.apiRoot+"resources/profile-images/"+fileImage.slug+"/"+fileImage.filename

			return false
		}
	},
	methods: {
		printPage() {
			window.print()
		},
		sendNotes(payload) {
			// Payload includes:
			//    additional - emails typed into modal
			//    employeeRecipients - user ids of employees
			//    recipients - user ids of subcontacts of customer

			let vm = this
			this.spinner(true)

			payload.job_id = this.project.id                 // Used to build URL
			payload.userIdList = payload.employeeRecipients  // List of internal employee ids to email
			payload.contactIdList = payload.recipients       // List of customer subcontact ids to email

			// No longer needed
			delete payload.employeeRecipients
			delete payload.recipients

			this.postData("JobNote/send", payload).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.sendModalVisible = false
					//vm.alertSuccess("Notes for Project #"+vm.project.job_num+" sent successfully.")

					vm.notes.map(note => {
						note.UploadFile.forEach(file => {

							file.sharing_on = 1
							vm.postData("UploadFile/update", file).then(fileResponse => {
								if (!fileResponse.success) {
									//vm.alertErrors("Note #"+vm.note.note_id+" attachment could not be posted.")
								} else {
								}
							})
						})
					})

				}
				else {
					//vm.alertErrors("Notes for Project #"+vm.project.job_num+" could not be sent.")
				}
			})
		},
		mutateNotes() {
			let vm = this
			vm.notes = vm.notes.map(note => {
				if ('created_at' in note && note.created_at)
					note.createdAt = vm.formatDateTimeToLocal(note.created_at, "full-date-time")

				if ('updated_at' in note && note.updated_at)
					note.updatedAt = vm.formatDateTimeToLocal(note.updated_at, "full-date-time")

				if ('updated_by' in note && note.updated_by)
					note.updatedBy = note.UpdatedBy.first_name + " " + note.UpdatedBy.last_name

				return note
			})
		},

		fetchProject() {
			let vm = this

			this.getJSON("Job/find/"+this.$route.params.slug, vm.jobPayload).then(response => {
				if (response.success) {
					vm.project = response.data
				}
			})
		},

		fetchNotes() {
			let vm = this

			vm.spinner(true)

			// Fetch each note for this job

			vm.notesPayload.filters = [
					["Job.slug", this.$route.params.slug]
			]

			this.getJSON("JobNote/get", vm.notesPayload).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.notes = response.data
					vm.fetchProject()
					vm.mutateNotes()
				}
			})
		}
	},
	created() {
		this.fetchNotes()
		this.$store.printMode = true
	}
}
</script>



<style type="text/css" scoped>
article {
	max-width: 1000px;
	margin: auto;
}

.form-details {
	margin-top: 30px;
	padding: 15px;
	background-color: #6c757d;
	color: white;
}

@media print {
	.form-button {
		display: none;
	}
}

.title {
	margin: 0px;
	padding: 0px;
}


.form-section pre {
	margin-bottom: 0;
}

.form-section-print-view {
	border: 1px solid #e0e0e0;
	padding: 15px;
	padding-top: 0;
	background-color: white;
}

.form-section-print-view h4 {
	padding: 15px;
	background: #6c757d;
	color: white;
	margin-left: -15px;
	margin-right: -15px;
	text-decoration: none;
}

.form-section-print-view.highlighted-section h4 {
	background: #b1690c;
}

.form-section-print-view .field-container {
	border-bottom: 1px solid #e0e0e07a;
}

.form-section-print-view .field {
	padding-top: 10px;
	padding-bottom: 10px;
}

.form-section-print-view .field:last-child {
	border-bottom: none;
}

.form-section-print-view .field h5 {
	margin-bottom: 0;
}

.form-section-print-view .field.field-type-boolean h5,
.form-section-print-view .field.field-type-text h5 {
	width: 80%;
}


@media print {
	pre {
		border: none!important;
	}

	article {
		background-color: white!important;
	}
}
</style>
